

<script>
import { Pie } from 'vue-chartjs'
import { setTimeout } from 'timers';
import 'chartjs-plugin-labels';
export default {
  extends: Pie,
  data() {
      return {
          comuser:0,
          couser:0,
          ruuser:0,
          piedata:[]
      }
  },
  mounted () {
    this.setData() 
    this.renderChart({
      labels: ['onedio.com','onedio.co','onedio.ru'],
      datasets: [
        {
          backgroundColor: [
            '#20a8d8',
            '#ffc107',
            '#4dbd74'
          ],
          data:this.piedata,
        }
      ],
      options:{
        plugins:{
          labels: {
            render: 'percentage',
            precision: 2,
            fontColor:'#000',
          }
        }
      }
    }, {responsive: true, maintainAspectRatio: true,
    })
      
  },
  methods: {
     async setData(){
        this.comuser=parseInt(this.$store.state.comUser.replace(/\./g,""))
        this.couser=parseInt(this.$store.state.coUser.replace(/\./g,""))
        this.ruuser=parseInt(this.$store.state.ruUser.replace(/\./g,""))
        this.piedata.push(this.comuser)
        this.piedata.push(this.couser)
        this.piedata.push(this.ruuser)
      }
  },
}
</script>
